module.exports = __webpack_public_path__ + "img/activities.393f6a3e.png";